module.exports = __webpack_public_path__ + "static/media/bgPay.6cb295f4.png";